import { memo } from 'react'

import { CueContext } from '@/features/rundown/cue/cue.context'

import { CueItem } from './CueItem'

export const Cue = memo(function Cue({ cueId }: { cueId: string }) {
  return (
    <CueContext.Provider value={cueId}>
      <CueItem key={cueId} />
    </CueContext.Provider>
  )
})
